import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useSiteQuery } from "../hooks"

function Seo({ description, lang, meta, title, node_locale }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  const  {mobileLogo}  = useSiteQuery() 
  let seoImage = mobileLogo.image.fluid.src
  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  switch(lang){
  case "uk/en":
    lang = "en"
    break
  case "us/en":
    lang = "en"
    break
    case "us/es":
      lang = "es"
      break 
    case "pl":
      lang = "pl"
      break
    case "ca/en":
      lang = "en"
      break
      case "ca/fr":
        lang = "fr"
        break
      case "tr":
        lang = "tr"
        break
    case "fr":
      lang = "fr"
      break
    default:
      lang= "en"
  }
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `market`,
          content : node_locale
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: `https:${seoImage}`
        },
        {
          property: `og:image:secure_url`,
          content: `https://secure.${seoImage.substr(2)}`
        },
        {
          property: `og:image:type`,
          content: `image/jpeg`
        },
        {
          property: `og:image:width`,
          content: `400`
        },
        {
          property: `og:image:height`,
          content: `300`
        },
        {
          property: `og:image:alt`,
          content: `ekaterra`
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
